export default function TextField(props) {
  return (
    <div className="form-group">
      <label className="form-label" htmlFor="name">
        {props.label}
      </label>
      <input
        type={props.type}
        className={"form-control form-control-lg " + props.error}
        id={props.id}
        name={props.name}
        value={props.value}
        onChange={props.change}
        placeholder={props.placeholder}
        disabled={props.disabled}
        maxLength={props.maxLength}
        required={props.required}
        autoComplete="off"
        style={props.disabled ? { backgroundColor: '#f5f5f5', opacity: 0.7 } : {}}
      />
    </div>
  );
}
